import React, { useState, useEffect, useRef } from "react";
import dots from "../assets/images/dots.svg";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import Modal from "react-bootstrap/Modal";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { SpinnerCircular } from "spinners-react";
import Dropdown from "react-bootstrap/Dropdown";
import http from "../services/http";
import ReactPaginate from "react-paginate";
import { Link, useLocation } from "react-router-dom";
import image1 from "../assets/images/copy.svg";

function AnalystsCheckBox(props) {
  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const token = localStorage.getItem("xAuthToken");
  const [key, setKey] = useState("home");
  const [loading, setLoading] = useState(true);
  const [analyst, setAnalyst] = useState([]);
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [showModals, setShows] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [isDeactivate, setisDeactivate] = useState(0);
  const [available, setAvailable] = useState([]);
  const [unavailable, setUnAvailable] = useState([]);
  const [suspend, setSuspend] = useState([]);
  const [checkedEmails, setCheckedEmails] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isAllAvailableChecked, setIsAllAvailableChecked] = useState(false);
  const [isAllSuspendChecked, setIsAllSuspendChecked] = useState(false);
  const [isAllUnavailableChecked, setIsAllUnavailableChecked] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [uploadSpin, setUploadSpin] = useState(false);
  const [message, setMessage] = useState("");

  const handleCloses = () => setShows(false);
  const handleShows = (id, is_deactivated) => {
    setisDeactivate(is_deactivated);
    setSelectedId(id);
    setShows(true);
  };
  useEffect(() => {
    Analyst();
  }, []);

  const Analyst = async () => {
    setLoading(true);

    http
      .get(`public/admin/analyst?token=${token}`)
      .then((res) => {
        setAnalyst(res.data);
        setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const InProgress = (k) => {
    setKey(k);
    switch (k) {
      case "home":
        setLoading(true);

        http
          .get(`public/admin/analyst?token=${token}`)
          .then((res) => {
            setAnalyst(res.data);
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);

            console.log("error==>", error);
          });
        break;
      case "Completed":
        setLoading(true);

        http
          .get(`public/admin/analyst/unavailable?token=${token}`)
          .then((res) => {
            setUnAvailable(res.data);
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;

      case "Suspend":
        setLoading(true);

        http
          .get(`public/admin/analyst/suspend?token=${token}`)
          .then((res) => {
            setSuspend(res.data);
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;
      default:
        setLoading(true);

        http
          .get(`public/admin/analyst/available?token=${token}`)
          .then((res) => {
            console.log("available=====>", res.data);
            setAvailable(res.data);
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            console.log("error==>", error);
            setLoading(false);
          });
        break;
    }
  };

  const handleNoSelection = () => {
    setShow(false);
  };

  const handleCheckboxChange = (email) => {
    setCheckedEmails((prevCheckedEmails) =>
      prevCheckedEmails.includes(email)
        ? prevCheckedEmails.filter((e) => e !== email)
        : [...prevCheckedEmails, email]
    );
  };

  const handleHeaderCheckboxChange = () => {
    if (isAllChecked) {
      setCheckedEmails([]);
    } else {
      const emails = analyst.map((item) => item.email);
      setCheckedEmails((prev) => [...new Set([...prev, ...emails])]);
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleAvailableHeaderCheckboxChange = () => {
    if (isAllAvailableChecked) {
      setCheckedEmails((prev) =>
        prev.filter(
          (email) => !available.map((item) => item.email).includes(email)
        )
      );
    } else {
      const emails = available.map((item) => item.email);
      setCheckedEmails((prev) => [...new Set([...prev, ...emails])]);
    }
    setIsAllAvailableChecked(!isAllAvailableChecked);
  };

  const handleUnavailableHeaderCheckboxChange = () => {
    if (isAllUnavailableChecked) {
      setCheckedEmails((prev) =>
        prev.filter(
          (email) => !unavailable.map((item) => item.email).includes(email)
        )
      );
    } else {
      const emails = unavailable.map((item) => item.email);
      setCheckedEmails((prev) => [...new Set([...prev, ...emails])]);
    }
    setIsAllUnavailableChecked(!isAllUnavailableChecked);
  };

  const handleSuspendHeaderCheckboxChange = () => {
    if (isAllSuspendChecked) {
      setCheckedEmails((prev) =>
        prev.filter(
          (email) => !suspend.map((item) => item.email).includes(email)
        )
      );
    } else {
      const emails = suspend.map((item) => item.email);
      setCheckedEmails((prev) => [...new Set([...prev, ...emails])]);
    }
    setIsAllSuspendChecked(!isAllSuspendChecked);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  const inputRef = useRef(null);

  const handleImageClick = () => {
    if (inputRef.current) {
      navigator.clipboard
        .writeText(inputRef.current.value)
        .then(() => {
          alert("text copied");
          setShow(true);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };

  const handleSelectedAnalyst = async () => {
    try {
      http.post(`public/admin/analyst/sendEmailToAll?token=${token}`, {
        analystEmail: checkedEmails,
        inputValue: inputValue,
      });
      if (inputValue.length > 6) {
        setShow(false);
      }
      if (inputValue) {
        window.open(inputValue, "_blank");
      } else {
        alert("Please enter an invitation link.");
      }
    } catch (error) {
      console.error("Error sending messages:", error);
      alert("Failed to send messages.");
    }
  };

  const Deactivate = async (id) => {
    setUploadSpin(true);
    if (isDeactivate === 0) {
      http
        .put(`api/admin/analyst/deactivate/${id}?token=${token}`)
        .then((res) => {
          console.log("deactivate----", res.status);
          setUploadSpin(false);

          if (res.status === 200) {
            handleCloses();
            Analyst();
            setSelectedId(0);
            setMessage(res.data.message);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setUploadSpin(false);
        });
    } else {
      http
        .put(`api/admin/analyst/activate/${id}?token=${token}`)
        .then((res) => {
          console.log("activate----", res.status);
          setUploadSpin(false);

          if (res.status === 200) {
            handleCloses();

            const remData = analyst.filter(function (obj) {
              return obj.id !== selectedId;
            });
            const availableRemData = available.filter(function (obj) {
              return obj.id !== selectedId;
            });
            const unavailableRemData = unavailable.filter(function (obj) {
              return obj.id !== selectedId;
            });
            setAnalyst(remData);
            setAvailable(availableRemData);
            setUnAvailable(unavailableRemData);
            setSelectedId(0);
            setMessage(res.data.message);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setUploadSpin(false);
        });
    }
  };

  const handleSuspend = async (id) => {
    setUploadSpin(true);
    http
      .put(`api/admin/analyst/suspend/${id}?token=${token}`, {
        is_suspended: 1, is_available: 0,
      })
      .then((res) => {
        setUploadSpin(false);
        if (res.status === 200) {
          handleCloses();
          Analyst();
          setSelectedId(0);
          setMessage(res.data.message);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setUploadSpin(false);
      });
  };

  const usersPerPage = 7;
  const pagesVisited = pageNumber * usersPerPage;
  const pageCountAnalyst = Math.ceil(analyst.length / usersPerPage);
  const pageCountAvailable = Math.ceil(available.length / usersPerPage);
  const pageCountUnavailable = Math.ceil(unavailable.length / usersPerPage);
  const pageCountsuspend = Math.ceil(suspend.length / usersPerPage);
  const listAnalyst = analyst.length;
  const listAvailable = available.length;
  const listUnavailable = unavailable.length;
  const listSuspend = suspend.length;

  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);

  const handleSendClick = () => {
    if (!inputValue.trim()) {
      alert("Please enter an invitation link."); 
      return; 
  }
    setIsConfirmModalVisible(true);
    setShow(false);
  };

  const handleConfirmSend = async () => {
    await handleSelectedAnalyst();
    setIsConfirmModalVisible(false);
  };

  const handleCancelSend = () => {
    setIsConfirmModalVisible(false);
    setShow(true);
  };

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  {" "}
                  <button
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link bt_none"
                  >
                    <i className="fa fa-align-left"></i>{" "}
                  </button>
                  <h1>Analysts</h1>
                </div>
                <DropdownRight />
              </div>
            </header>
            <div className="dashbord_content">
              <div className="analysts-wraper-head">
                <div className="personal_and_bank_info Analysts_tabs">
                  <div
                    className="map_btn tabs_google_meet"
                    // style={{
                    //   marginLeft: 750,
                    //   width: 300,
                    //   height: 100,
                    //   marginBottom: -120,
                    // }}
                  >
                    {" "}
                    <button
                      style={{
                        marginTop: 40,
                        marginLeft: 42,
                        opacity: checkedEmails.length === 0 ? 0.5 : 1,
                        cursor:
                          checkedEmails.length === 0
                            ? "not-allowed"
                            : "pointer",
                      }}
                      onClick={handleShow}
                      className="them_btn invite_btn"
                      type="button"
                      data-toggle="modal"
                      data-target="#Google_Meet"
                      disabled={checkedEmails.length === 0}
                    >
                      Send Invite
                    </button>{" "}
                  </div>
                  <Tabs
                    activeKey={key}
                    onSelect={(k) => InProgress(k)}
                    style={{
                      alignItems: "center",
                      width: 630,
                      borderRadius: 5,
                      marginTop: 50,
                      backgroundColor: "#dee2e6",
                      padding: 10,
                    }}
                    defaultActiveKey="profile"
                    id="uncontrolled-tab-example"
                    className="mb-3 nav nav-pills border-bottom-0"
                  >
                    <Tab
                      eventKey="home"
                      title="  All"
                      style={{ marginTop: 10 }}
                    >
                      <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                        <table className="table table-borderless table-responsive-xl">
                          <thead>
                            <tr>
                              <th className="pl_25">
                                <label className="check_box">
                                  <input
                                    type="checkbox"
                                    checked={isAllChecked}
                                    onChange={handleHeaderCheckboxChange}
                                  />{" "}
                                  <span className="checkmark"></span>{" "}
                                </label>
                              </th>
                              {/* <th scope="col">Analyst ID</th> */}
                              <th scope="col" className=" ">
                                Analyst Name
                              </th>
                              <th scope="col" className=" ">
                                Email ID
                              </th>
                              <th scope="col" className=" ">
                                Cell Number
                              </th>
                              <th scope="col" className=" ">
                                Level
                              </th>
                              <th scope="col" className="  text-center">
                                Status
                              </th>
                              <th scope="col" className="  ">
                                {" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <div
                                style={{
                                  position: "absolute",
                                  marginTop: 250,
                                  backgroundColor: "#ffffffc2",
                                  marginLeft: 580,

                                  backgroundBlendMode: "overlay",
                                  zIndex: 100,
                                }}
                              >
                                <SpinnerCircular size="15%" />
                              </div>
                            ) : (
                              <>
                                {analyst
                                  .slice(
                                    pagesVisited,
                                    pagesVisited + usersPerPage
                                  )
                                  ?.map((item) => (
                                    <tr data-id={item.id}>
                                      <td className="pl_25">
                                        <label className="check_box">
                                          <input
                                            type="checkbox"
                                            checked={checkedEmails.includes(
                                              item.email
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(item.email)
                                            }
                                          />{" "}
                                          <span className="checkmark"></span>{" "}
                                        </label>
                                      </td>
                                      {/* <td className="pl_25">{item.id} </td> */}
                                      <td>
                                        {" "}
                                        {item.firstname} {item.lastname}
                                      </td>
                                      <td className="email_ids">
                                        {item.email}
                                      </td>
                                      <td>{item.phone}</td>
                                      <td>
                                        {item.level ? item.level : "Beginner"}
                                      </td>

                                      <td>
                                        <div className="btn_wraper d-flex justify-content-center  ">
                                          <div className="btn_Subscribed">
                                            {" "}
                                            <button
                                              type="button"
                                              className={
                                                "" +
                                                (  item.is_suspended === 1
                                                  ? "them_btn_suspended"
                                                  : item.is_available === 1
                                                  ? "them_btn_Subscribed"
                                                  : "them_btn_Unsubscribed")
                                              }
                                            >
                                              {item.is_suspended === 1
                                                ? "Suspended"
                                                : item.is_available === 1
                                                ? "Available"
                                                : "UnAvailable"}
                                            </button>{" "}
                                          </div>
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        <div className="dropdown wraper_btn">
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              className="btn dropdown-toggle"
                                              variant="success"
                                              id="dropdown-basic"
                                            >
                                              <img
                                                src={dots}
                                                className="img-fulid  "
                                              />
                                              <span className="caret"></span>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu
                                              as="ul"
                                              className="dropul"
                                            >
                                              <Dropdown.Item as="li">
                                                <Link
                                                  to="/editAnalystProfile"
                                                  state={{
                                                    id: item.id,
                                                    analyst: item,
                                                  }}
                                                  className="link"
                                                >
                                                  View Profile
                                                </Link>
                                              </Dropdown.Item>
                                              <Dropdown.Item as="li">
                                                <Link
                                                  to="/analystsIntermediate"
                                                  state={{
                                                    id: item.id,
                                                    name: `${item.firstname} ${item.lastname}`,
                                                    isdeactivate:
                                                      item.is_deactivated,
                                                  }}
                                                  className="link"
                                                >
                                                  View Works
                                                </Link>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                as="li"
                                                onClick={() =>
                                                  handleSuspend(item.id)
                                                }
                                              >
                                                Suspend
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                to="#/action-2"
                                                as="li"
                                                onClick={() =>
                                                  Deactivate(
                                                    item.id,
                                                    item.is_deactivated
                                                  )
                                                }
                                              >
                                                {item.is_deactivated === 1
                                                  ? "Activate"
                                                  : " Deactivate"}
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </>
                            )}
                          </tbody>
                        </table>
                        <div className="pagination">
                          <div className="paginateText">
                            <p className="text-table-show">
                              {" "}
                              Showing{" "}
                              {/* {
                                analyst.slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                ).length
                              }{" "}
                              out of {listAnalyst} entries */}
                              {listAnalyst != 0 ? (pageNumber === pageCountAnalyst - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumber)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
                              {listAnalyst} entries
                            </p>
                          </div>
                          <div className="reactPaginate">
                            <ReactPaginate
                              previousLabel={"<<"}
                              nextLabel={">>"}
                              pageCount={pageCountAnalyst}
                              onPageChange={changePage}
                              containerClassName={"paginationBttns"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"paginationDisabled"}
                              activeClassName={"paginationActive"}
                              forcePage={pageNumber}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>

                    <Tab
                      eventKey="Progress"
                      title=" Available"
                      style={{ marginTop: 40 }}
                    >
                      <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                        <table className="table table-borderless table-responsive-xl">
                          <thead>
                            <tr>
                              <th className="pl_25">
                                <label className="check_box">
                                  <input
                                    type="checkbox"
                                    checked={isAllAvailableChecked}
                                    onChange={
                                      handleAvailableHeaderCheckboxChange
                                    }
                                  />{" "}
                                  <span className="checkmark"></span>{" "}
                                </label>
                              </th>
                              {/* <th scope="col" className="  ">
                                Analyst ID
                              </th> */}
                              <th scope="col" className=" ">
                                Analyst Name
                              </th>
                              <th scope="col" className=" ">
                                Email ID
                              </th>
                              <th scope="col" className=" ">
                                Cell Number
                              </th>
                              <th scope="col" className=" ">
                                Level
                              </th>
                              <th scope="col" className="  text-center">
                                Status
                              </th>
                              <th scope="col" className="  ">
                                {" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {available
                              .slice(pagesVisited, pagesVisited + usersPerPage)
                              ?.map((item) => (
                                <tr>
                                  <td className="pl_25">
                                    <label className="check_box">
                                      <input
                                        type="checkbox"
                                        checked={checkedEmails.includes(
                                          item.email
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(item.email)
                                        }
                                      />{" "}
                                      <span className="checkmark"></span>{" "}
                                    </label>
                                  </td>
                                  {/* <td className="pl_25">{item.id} </td> */}
                                  <td>
                                    {" "}
                                    {item.firstname} {item.lastname}
                                  </td>
                                  <td style={{ wordBreak: "break-all" }}>
                                    {item.email}
                                  </td>
                                  <td>{item.phone}</td>
                                  <td>
                                    {item.level ? item.level : "Beginner"}
                                  </td>
                                  <td>
                                    <div className="btn_wraper d-flex justify-content-center  ">
                                      <div className="btn_Subscribed">
                                        {" "}
                                        <button
                                          type="button"
                                          className={
                                            "" +
                                            (item.is_available === 1
                                              ? "them_btn_Subscribed"
                                              : item.is_suspended === 1
                                              ? "them_btn_suspended"
                                              : "them_btn_Unsubscribed")
                                          }
                                        >
                                          {item.is_available === 1
                                            ? "Available"
                                            : item.is_suspended === 1
                                            ? "Suspended"
                                            : "UnAvailable"}
                                        </button>{" "}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="dropdown wraper_btn">
                                      <Dropdown>
                                        <Dropdown.Toggle
                                          className="btn dropdown-toggle"
                                          variant="success"
                                          id="dropdown-basic"
                                        >
                                          <img
                                            src={dots}
                                            className="img-fulid  "
                                          />
                                          <span className="caret"></span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                          as="ul"
                                          className="dropul"
                                        >
                                          <Dropdown.Item as="li">
                                            <Link
                                              to="/editAnalystProfile"
                                              state={{
                                                id: item.id,
                                                analyst: item,
                                              }}
                                              className="link"
                                            >
                                              View Profile
                                            </Link>
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-1"
                                            as="li"
                                          >
                                            <Link
                                              to="/analystsIntermediate"
                                              state={{
                                                id: item.id,
                                                name: `${item.firstname} ${item.lastname}`,
                                                isdeactivate:
                                                  item.is_deactivated,
                                              }}
                                              className="link"
                                            >
                                              View Works
                                            </Link>
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            as="li"
                                            onClick={() =>
                                              handleSuspend(item.id)
                                            }
                                          >
                                            Suspend
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-2"
                                            as="li"
                                            onClick={() =>
                                              Deactivate(
                                                item.id,
                                                item.is_deactivated
                                              )
                                            }
                                          >
                                            {item.is_deactivated === 1
                                              ? "Activate"
                                              : " Deactivate"}
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="pagination">
                          <div className="paginateText">
                            <p className="text-table-show">
                              {" "}
                              Showing{" "}
                              {/* {
                                available.slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                ).length
                              }{" "}
                              out of {listAvailable} entries */}
                              {listAvailable != 0 ? (pageNumber === pageCountAvailable - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumber)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
                              {listAvailable} entries
                            </p>
                          </div>
                          <div className="reactPaginate">
                            <ReactPaginate
                              previousLabel={"<<"}
                              nextLabel={">>"}
                              pageCount={pageCountAvailable}
                              onPageChange={changePage}
                              containerClassName={"paginationBttns"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"paginationDisabled"}
                              activeClassName={"paginationActive"}
                              forcePage={pageNumber}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="Completed"
                      title="Unavailable"
                      style={{ marginTop: 40 }}
                    >
                      <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                        <table className="table table-borderless table-responsive-xl">
                          <thead>
                            <tr>
                              <th className="  pl_25">
                                <label className="check_box">
                                  <input
                                    type="checkbox"
                                    checked={isAllUnavailableChecked}
                                    onChange={
                                      handleUnavailableHeaderCheckboxChange
                                    }
                                  />{" "}
                                  <span className="checkmark"></span>{" "}
                                </label>
                              </th>
                              {/* <th scope="col">Analyst ID</th> */}
                              <th scope="col" className=" ">
                                Analyst Name
                              </th>
                              <th scope="col" className=" ">
                                Email ID
                              </th>
                              <th scope="col" className=" ">
                                Cell Number
                              </th>
                              <th scope="col" className=" ">
                                Level
                              </th>
                              <th scope="col" className="  text-center">
                                Status
                              </th>
                              <th scope="col" className="  ">
                                {" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {unavailable
                              .slice(pagesVisited, pagesVisited + usersPerPage)
                              ?.map((item) => (
                                <tr>
                                  <td className="pl_25">
                                    <label className="check_box">
                                      <input
                                        type="checkbox"
                                        checked={checkedEmails.includes(
                                          item.email
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(item.email)
                                        }
                                      />{" "}
                                      <span className="checkmark"></span>{" "}
                                    </label>
                                  </td>
                                  {/* <td className="pl_25">{item.id} </td> */}
                                  <td>
                                    {" "}
                                    {item.firstname} {item.lastname}
                                  </td>
                                  <td style={{ wordBreak: "break-all" }}>
                                    {item.email}
                                  </td>
                                  <td>{item.phone}</td>
                                  <td>
                                    {item.level ? item.level : "Beginner"}
                                  </td>
                                  <td>
                                    <div className="btn_wraper d-flex justify-content-center  ">
                                      <div className="btn_Subscribed">
                                        {" "}
                                        <button
                                          type="button"
                                          className={
                                            "" +
                                            (item.is_available === 1
                                              ? "them_btn_Subscribed"
                                              : item.is_suspended === 1
                                              ? "them_btn_suspended"
                                              : "them_btn_Unsubscribed")
                                          }
                                        >
                                          {item.is_available === 1
                                            ? "Available"
                                            : item.is_suspended === 1
                                            ? "Suspended"
                                            : "UnAvailable"}
                                        </button>{" "}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="dropdown wraper_btn">
                                      <Dropdown>
                                        <Dropdown.Toggle
                                          className="btn dropdown-toggle"
                                          variant="success"
                                          id="dropdown-basic"
                                        >
                                          <img
                                            src={dots}
                                            className="img-fulid  "
                                          />
                                          <span className="caret"></span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                          as="ul"
                                          className="dropul"
                                        >
                                          <Dropdown.Item as="li">
                                            <Link
                                              to="/editAnalystProfile"
                                              state={{
                                                id: item.id,
                                                analyst: item,
                                              }}
                                              className="link"
                                            >
                                              View Profile
                                            </Link>
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-1"
                                            as="li"
                                          >
                                            <Link
                                              to="/analystsIntermediate"
                                              state={{
                                                id: item.id,
                                                name: `${item.firstname} ${item.lastname}`,
                                                isdeactivate:
                                                  item.is_deactivated,
                                              }}
                                              className="link"
                                            >
                                              View Works
                                            </Link>
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            as="li"
                                            onClick={() =>
                                              handleSuspend(item.id)
                                            }
                                          >
                                            Suspend
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-2"
                                            as="li"
                                            onClick={() =>
                                              Deactivate(
                                                item.id,
                                                item.is_deactivated
                                              )
                                            }
                                          >
                                            {item.is_deactivated === 1
                                              ? "Activate"
                                              : " Deactivate"}
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="pagination">
                          <div className="paginateText">
                            <p className="text-table-show">
                              {" "}
                              Showing{" "}
                              {/* {
                                unavailable.slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                ).length
                              }{" "}
                              out of {listUnavailable} entries */}
                              {listUnavailable != 0 ? (pageNumber === pageCountUnavailable - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumber)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
                              {listUnavailable} entries
                            </p>
                          </div>
                          <div className="reactPaginate">
                            <ReactPaginate
                              previousLabel={"<<"}
                              nextLabel={">>"}
                              pageCount={pageCountUnavailable}
                              onPageChange={changePage}
                              containerClassName={"paginationBttns"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"paginationDisabled"}
                              activeClassName={"paginationActive"}
                              forcePage={pageNumber}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="Suspend"
                      title="Suspend"
                      style={{ marginTop: 40 }}
                    >
                      <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                        <table className="table table-borderless table-responsive-xl">
                          <thead>
                            <tr>
                              <th className="  pl_25">
                                <label className="check_box">
                                  <input
                                    type="checkbox"
                                    checked={isAllSuspendChecked}
                                    onChange={handleSuspendHeaderCheckboxChange}
                                  />{" "}
                                  <span className="checkmark"></span>{" "}
                                </label>
                              </th>
                              {/* <th scope="col">Analyst ID</th> */}
                              <th scope="col" className=" ">
                                Analyst Name
                              </th>
                              <th scope="col" className=" ">
                                Email ID
                              </th>
                              <th scope="col" className=" ">
                                Cell Number
                              </th>
                              <th scope="col" className=" ">
                                Level
                              </th>
                              <th scope="col" className="  text-center">
                                Status
                              </th>
                              <th scope="col" className="  ">
                                {" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {suspend
                              .slice(pagesVisited, pagesVisited + usersPerPage)
                              ?.map((item) => (
                                <tr>
                                  <td className="pl_25">
                                    <label className="check_box">
                                      <input
                                        type="checkbox"
                                        checked={checkedEmails.includes(
                                          item.email
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(item.email)
                                        }
                                      />{" "}
                                      <span className="checkmark"></span>{" "}
                                    </label>
                                  </td>
                                  {/* <td className="pl_25">{item.id} </td> */}
                                  <td>
                                    {" "}
                                    {item.firstname} {item.lastname}
                                  </td>
                                  <td style={{ wordBreak: "break-all" }}>
                                    {item.email}
                                  </td>
                                  <td>{item.phone}</td>
                                  <td>
                                    {item.level ? item.level : "Beginner"}
                                  </td>
                                  <td>
                                    <div className="btn_wraper d-flex justify-content-center  ">
                                      <div className="btn_Subscribed">
                                        {" "}
                                        <button
                                          type="button"
                                          className={
                                            "" +
                                            (item.is_available === 1
                                              ? "them_btn_Subscribed"
                                              : item.is_suspended === 1
                                              ? "them_btn_suspended"
                                              : "them_btn_Unsubscribed")
                                          }
                                        >
                                          {item.is_available === 1
                                            ? "Available"
                                            : item.is_suspended === 1
                                            ? "Suspended"
                                            : "UnAvailable"}
                                        </button>{" "}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="dropdown wraper_btn">
                                      <Dropdown>
                                        <Dropdown.Toggle
                                          className="btn dropdown-toggle"
                                          variant="success"
                                          id="dropdown-basic"
                                        >
                                          <img
                                            src={dots}
                                            className="img-fulid  "
                                          />
                                          <span className="caret"></span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                          as="ul"
                                          className="dropul"
                                        >
                                          <Dropdown.Item as="li">
                                            <Link
                                              to="/editAnalystProfile"
                                              state={{
                                                id: item.id,
                                                analyst: item,
                                              }}
                                              className="link"
                                            >
                                              View Profile
                                            </Link>
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-1"
                                            as="li"
                                          >
                                            <Link
                                              to="/analystsIntermediate"
                                              state={{
                                                id: item.id,
                                                name: `${item.firstname} ${item.lastname}`,
                                                isdeactivate:
                                                  item.is_deactivated,
                                              }}
                                              className="link"
                                            >
                                              View Works
                                            </Link>
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            as="li"
                                            onClick={() =>
                                              handleSuspend(item.id)
                                            }
                                          >
                                            Suspend
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            to="#/action-2"
                                            as="li"
                                            onClick={() =>
                                              Deactivate(
                                                item.id,
                                                item.is_deactivated
                                              )
                                            }
                                          >
                                            {item.is_deactivated === 1
                                              ? "Activate"
                                              : " Deactivate"}
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="pagination">
                          <div className="paginateText">
                            <p className="text-table-show">
                              {" "}
                              Showing{" "}
                              {/* {
                                suspend.slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                ).length
                              }{" "}
                              out of {listSuspend} entries */}
                              {listSuspend != 0 ? (pageNumber === pageCountsuspend - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumber)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
                              {listSuspend} entries
                            </p>
                          </div>
                          <div className="reactPaginate">
                            <ReactPaginate
                              previousLabel={"<<"}
                              nextLabel={">>"}
                              pageCount={pageCountsuspend}
                              onPageChange={changePage}
                              containerClassName={"paginationBttns"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"paginationDisabled"}
                              activeClassName={"paginationActive"}
                              forcePage={pageNumber}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade starrating"
            id="createadmin"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="createadmin"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="createadmin">
                    Create new admin
                  </h5>{" "}
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </div>
                <div className="modal-body">
                  <div className="raing_star">
                    {/*   <p>
                    Lorem ipsum dolor sit amet, consectetur adiet cing elit. nun
                    c non risus condiment loborti
                  </p> */}
                    <div className="form-group  mt-3">
                      {" "}
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email ID"
                      />{" "}
                    </div>
                  </div>
                  <div className="modal-footer border-top-0">
                    {" "}
                    <button type="button" className="them_btn_ouline ">
                      Cancel
                    </button>{" "}
                    <button type="button" className="them_btn ">
                      Send Invite
                    </button>{" "}
                    <Modal show={showModal} onHide={handleClose}>
                      <Modal.Header closeButton>
                        <Modal.Title>Send Meeting invite</Modal.Title>
                        <button
                          onClick={handleClose}
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          {" "}
                          <span aria-hidden="true">&times;</span>{" "}
                        </button>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="raing_star">
                          <p>
                            If you are sure you want to invite the selected analyst(S) for a meeting, please enter invitation link below.
                          </p>
                        </div>
                        <div class="form-group icon mt-3 w-100">
                          {" "}
                          <input
                            type="text"
                            class="form-control input_field"
                            placeholder="Enter invitation link here..."
                            ref={inputRef}
                            value={inputValue}
                            onChange={handleInputChange}
                          />
                          <div class="img_icon">
                            <img
                              src={image1}
                              alt="copy"
                              onClick={handleImageClick}
                            />{" "}
                          </div>
                        </div>
                        <div className="modal-footer border-top-0 confirmation_button">
                          {" "}
                          <button
                            type="button"
                            className="them_btn_ouline sendToAll"
                            onClick={handleNoSelection}
                          >
                            Cancel
                          </button>{" "}
                          <button
                            type="button"
                            className="them_btn "
                            onClick={handleSendClick}
                          >
                            Send
                          </button>{" "}
                        </div>
                      </Modal.Body>
                    </Modal>
                    <Modal show={isConfirmModalVisible} onHide={handleClose}>
                      <Modal.Header closeButton>
                        <Modal.Title>Are you sure</Modal.Title>
                        <button
                          onClick={handleCancelSend}
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          {" "}
                          <span aria-hidden="true">&times;</span>{" "}
                        </button>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="raing_star">
                          <p>
                          Are you sure you want to send this invitation?
                          </p>
                        </div>
                        
                        <div className="modal-footer border-top-0 confirmation_button">
                          {" "}
                          <button
                            type="button"
                            className="them_btn_ouline sendToAll"
                            onClick={handleCancelSend}
                          >
                            No
                          </button>{" "}
                          <button
                            type="button"
                            className="them_btn "
                            onClick={handleConfirmSend}
                          >
                            Yes
                          </button>{" "}
                          
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default AnalystsCheckBox;
